import * as t from "io-ts";
import { ContactInfo } from "./ContactInfo";
import { Document } from "./Document";
import { LatLng } from "./LatLng";
import { WorkType } from "./WorkType";

export const TradeSummary = t.partial({
  id: t.string,
  contact_info: ContactInfo,
  trading_type: t.string,
  company_logo: Document,
  work_types: t.array(WorkType),
  lat_lng: LatLng,
  distance: t.number,
});

export interface TradeSummary {
  id?: string;
  contact_info?: ContactInfo;
  trading_type?: string;
  company_logo?: Document;
  work_types?: Array<WorkType>;
  lat_lng?: LatLng;
  distance?: number;
}
